import * as classnames from "classnames";

import { Markdown, Msg } from "@shared/components";
import { ApplicantExamModel } from "@shared/models";
import { SubmissionType } from "@shared/services/enums";

const tutorialFinishedImageSrc = require("../../../assets/images/tutorial_finished.png");
const notAllowedImageSrc = require("../../../assets/images/not_allowed.png");

/**
 * Prop interface
 */
export interface ExamFinishedProps {
  exam: ApplicantExamModel;
}

/**
 * Page component
 */
const ExamFinished = ({ exam: applicantExam }: ExamFinishedProps) => {
  const { exam, submissionType } = applicantExam;

  const rootStyle = classnames("code-exam-finished");

  const goodJobDisplay = (
    <>
      <div className="code-exam-finished__header">
        <p className="code-exam-finished__title">
          <Msg id="editor-exam-finished.goodJob" />
        </p>
        <p className="code-exam-finished__subtitle">
          {submissionType === SubmissionType.Automatic && (
            <Msg id="editor-exam-finished.autoSubmitted" />
          )}
          {submissionType === SubmissionType.Default && (
            <Msg id="editor-exam-finished.ifYouHadIssues" />
          )}
        </p>
      </div>
      <figure className="code-exam-finished__image-container">
        <img
          className="code-exam-finished__image"
          src={tutorialFinishedImageSrc}
        />
      </figure>
    </>
  );

  const errorDisplay = (
    <>
      <figure className="code-exam-finished__image-container code-exam-finished__error">
        <img src={notAllowedImageSrc} />
      </figure>
      <div className="code-exam-finished__header code-exam-finished__header__error">
        <p className="code-exam-finished__title code-exam-finished__title__error">
          <Msg id="editor-exam-finished.notAvailable" />
        </p>
        <p>
          {submissionType === SubmissionType.Deadline && (
            <Msg id="editor-exam-finished.deadlineReached" />
          )}
          {submissionType === SubmissionType.ManualOverride && (
            <Msg id="editor-exam-finished.manualSubmitted" />
          )}
        </p>
      </div>
    </>
  );

  const isGoodJobDisplay = [
    SubmissionType.Default,
    SubmissionType.Automatic,
  ].includes(submissionType);

  return (
    <div className={rootStyle}>
      <div className="code-exam-finished__container">
        {isGoodJobDisplay ? goodJobDisplay : errorDisplay}
        {exam.nextStepInfo && (
          <div className="code-exam-finished__follow-up">
            <p
              className={classnames("code-exam-finished__title", {
                "code-exam-finished__title__next-steps": !isGoodJobDisplay,
              })}
            >
              <Msg id="editor-exam-finished.nextSteps" />
            </p>
            <div>
              <Markdown body={exam.nextStepInfo} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExamFinished;
